import { CheckOutlined, ContentCopy } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';
import MDGapWrapper from '../MDRenderer/utilComponents/MDGapWrapper';

interface IMDCopyFieldProps {
	fieldName: string;
	displayName: string;
	disabled?: boolean;
	value: string | null | undefined;
}

const MDCopyField: React.FC<IMDCopyFieldProps> = ({
	fieldName,
	displayName,
	disabled = false,
	value
}) => {
	const [copiedText, copy] = useCopyToClipboard();

	const copyValueToClipboard = useCallback(async () => {
		await copy(value || '');
	}, [copy, value]);

	return (
		<MDGapWrapper>
			<TextField
				size="small"
				name={fieldName}
				sx={{
					display: 'block'
				}}
				disabled={disabled}
				label={displayName}
				value={value || ''}
				slotProps={{
					inputLabel: { shrink: true },
					input: {
						readOnly: true,
						sx: {
							width: '100%'
						},
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									data-testid="field-copy-button"
									size="small"
									onClick={copyValueToClipboard}
								>
									{copiedText === value ? (
										<CheckOutlined
											fontSize="small"
											data-testid="copy-success-icon"
										/>
									) : (
										<ContentCopy fontSize="small" />
									)}
								</IconButton>
							</InputAdornment>
						)
					}
				}}
			/>
		</MDGapWrapper>
	);
};

export default MDCopyField;
